import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import { PCC_SEARCH_INDEX } from "../../lib/pccSearchIndex";

export default function PccSearch({ compact = false }) {
  const [q, setQ] = useState("");
  const results = useMemo(() => {
    const query = q.trim().toLowerCase();
    if (!query) return [];
    return PCC_SEARCH_INDEX.filter((item) => {
      const haystack = [item.title, item.description, item.category, ...(item.keywords || [])]
        .join(" ")
        .toLowerCase();
      return haystack.includes(query);
    }).slice(0, compact ? 6 : 10);
  }, [q, compact]);

  return (
    <div className="relative" data-testid="pcc-search">
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-muted" strokeWidth={2} />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={compact ? "Search PCC tools & resources…" : "Search tools & resources — e.g. medication, invoice, incident, day rate"}
          className={`w-full rounded-full border border-slate-200 bg-white pl-11 pr-4 focus:outline-none focus:border-purple focus:ring-2 focus:ring-purple/20 ${compact ? "py-2.5 text-sm" : "py-3.5 text-sm md:text-base"}`}
          data-testid="pcc-search-input"
        />
      </div>
      {results.length > 0 && (
        <div
          className="absolute z-20 mt-2 w-full rounded-2xl border border-slate-200 bg-white shadow-lg overflow-hidden max-h-80 overflow-y-auto"
          data-testid="pcc-search-results"
        >
          {results.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="flex items-start gap-3 px-4 py-3 hover:bg-slate-50 border-b border-slate-100 last:border-0"
              data-testid={`pcc-search-result-${item.href.replace(/[^a-z0-9]/gi, "-")}`}
            >
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-ink truncate">{item.title}</div>
                <div className="text-xs text-ink-muted truncate">{item.description}</div>
                <div className="text-[11px] text-purple mt-0.5">{item.category}</div>
              </div>
              <ArrowRight className="w-4 h-4 text-ink-muted shrink-0 mt-1" strokeWidth={2} />
            </Link>
          ))}
        </div>
      )}
      {q.trim() && results.length === 0 && (
        <div
          className="absolute z-20 mt-2 w-full rounded-2xl border border-slate-200 bg-white p-4 text-sm text-ink-muted shadow-lg"
          data-testid="pcc-search-empty"
        >
          No matches for "{q}". Try a different word, or browse by topic below.
        </div>
      )}
    </div>
  );
}
